import { Component, Input, OnInit } from '@angular/core';
import { SharedHttpService } from '../../services/shared-http.service';

@Component({
  selector: 'app-ajudication-log-history',
  templateUrl: './ajudication-log-history.component.html',
  styleUrls: ['./ajudication-log-history.component.scss']
})
export class AjudicationLogHistoryComponent implements OnInit {
  @Input() eAdjudicationId:any; 

  logHistoryArr:any=[];
  constructor(private sharedService:SharedHttpService) { }

  ngOnInit(): void {
    this.sharedService.get(`api/Adjudication/getHistory?eAdjudicationId=${this.eAdjudicationId}`).subscribe(res=>{
      res.map(el=>{
          el.description = el.description.split('\n').join('<br/>')
      })
      this.logHistoryArr=res;
    })
  }

   

}
